import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/common.scss";
import "./styles/button.scss";
import "./styles/light-box.scss";
import "./index.css";
import { DialogContextProvider } from "./components/dialogs/Dialog";
import { BottomSheetContextProvider } from "./components/dialogs/bottomsheet";
import { AccountListContextProvider } from "./context/accountListContext";
import { ProductListContextProvider } from "./context/productListContext";
import { ConstListContextProvider } from "./context/constListContext";

function heightResize() {
  let vh = window.innerHeight;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

window.addEventListener("resize", heightResize);
heightResize();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConstListContextProvider>
    <AccountListContextProvider>
      <ProductListContextProvider>
        <DialogContextProvider>
          <BottomSheetContextProvider>
            <App />
          </BottomSheetContextProvider>
        </DialogContextProvider>
      </ProductListContextProvider>
    </AccountListContextProvider>
  </ConstListContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
